module.exports = __webpack_public_path__ + "img/职工3级@3x.56e9ac05.png";